import React from 'react';
import classes from './Header.module.css';
import Slider from './Headercomp/Slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope,faPhone, faSearch,} from '@fortawesome/free-solid-svg-icons'
import { faReddit,faFacebook,faInstagram,faTwitter } from '@fortawesome/free-brands-svg-icons';
import Navbar from './Headercomp/navbar';

const Headerr = props => {
    return (
        <header className={classes['header-area']}>
            <div className={classes['header-top-area']}>
                <div className={classes.topbar}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7 col-lg-6 col-sm-8">
                                <div className={classes['call-to-action']}>
      
                                    <p><a><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon> Email:abc@gmail.com</a></p>
                                    <p><a><FontAwesomeIcon icon={faPhone}></FontAwesomeIcon> Telephone:213456484</a></p>
                                </div>
                            </div>
                            <div className="col-md-5 col-lg-6 col-sm-4">
                                <div className={classes["book-table-popup"]}>
                                    <a href="">Book A Table</a>
                                </div>
                                <div className={classes['social-bookmarks']}>
                                    <ul>
                                        <li><a href=""><FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon></a></li>
                                        <li><a href=""><FontAwesomeIcon icon={faTwitter}></FontAwesomeIcon></a></li>
                                        <li><a href=""><FontAwesomeIcon icon={faInstagram}></FontAwesomeIcon></a></li>
                                        <li><a href=""><FontAwesomeIcon icon={faReddit}></FontAwesomeIcon></a></li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* MAIN MENU AREA */}
                <Navbar/>
            </div>
            
            <Slider/>
        </header>
    )
}
export default Headerr;